import { defineStore } from 'pinia'
import type { Undefinable } from 'ts-helpers'
import { ref } from 'vue'
import { usePageLoading } from '@/6_shared/composables'
import { slideService } from '../api'
import { SlideAdapter } from './adapter.ts'
import { type Slide, SlideLocation, type SliderResponse } from './type.d'

export const useSlide = defineStore('slide', () => {
  const slidesDesktop = ref<Undefinable<Slide[]>>(undefined)
  const slidesMobile = ref<Undefinable<Slide[]>>(undefined)

  const setSlides = (slidesData: SliderResponse) => {
    slidesDesktop.value = slidesData.desktop.map((slide) => new SlideAdapter(slide))
    slidesMobile.value = slidesData.mobile.map((slide) => new SlideAdapter(slide))
  }
  const resetSlides = () => {
    slidesDesktop.value = undefined
    slidesMobile.value = undefined
  }

  const { initialized: slidesInitialized, load: loadSlides } = usePageLoading()
  const getSlides = async (slug: SlideLocation) => {
    await loadSlides(
      async () => {
        resetSlides()
        const slides = await slideService.getAll(slug)
        setSlides(slides)
      },
      (e: any) => {
        console.error('failed to load slides ', e)
      }
    )
  }

  return {
    slidesDesktop,
    slidesMobile,
    slidesInitialized,
    getSlides
  }
})
